module.exports = __webpack_public_path__ + "media/images/icon/i-arrow-white-3d9437460a94521de9b7b0942024845b.svg";